// export const url = 'https://apimoca.polimentes.com/';
export const url = 'https://stage-ple-0001.polimentes.com/';
// export const url = 'http://192.168.68.150:8900/';
export const urlLanding = 'https://testlandingspagescontacts.polimentes.mx/';
export const vers = '2.4.16';